import { Modal } from "react-bootstrap";

function ExInfoModal({ onSubmit, onClose, show }) {
  return (
    <Modal show={show} size="xl" centered>
      <Modal.Header>
        <h3>استعلام قیمت</h3>
      </Modal.Header>
      <Modal.Body>
        <h5>کاربر گرامی</h5>
        <h6>
          نتیجه پس از استعلام قیمت از سرویس دهنده های مختلف ، به وسیله ی پیامک
          حداکثر تا 24 ساعت آینده به شما اعلام می گردد.
        </h6>
      </Modal.Body>
      <Modal.Footer className="d-flex flex-wrap">
        <button
          className="btn-success-style d-flex align-items-center justify-content-center"
          type="button"
          onClick={onSubmit}
        >
          تایید و ثبت
        </button>
        <button
          className="btn-cancel-style d-flex align-items-center justify-content-center"
          type="button"
          onClick={onClose}
        >
          بستن
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ExInfoModal;
